import { CompleteTodoEvent } from './complete-todo/complete-todo.event';
import { IncompleteTodoEvent } from './incomplete-todo/incomplete-todo.event';
import { CreateTodoEvent } from './create-todo/create-todo.event';
import { UpdateTodoEvent } from './update-todo/update-todo.event';

import { defineEvents } from '@iwentsourcing/core/stream/define-events.js';

export const todoEvents = defineEvents([
  CreateTodoEvent,
  CompleteTodoEvent,
  IncompleteTodoEvent,
  UpdateTodoEvent,
]);

export type TodoEvents = typeof todoEvents;
